import { useEffect, useState } from 'react'
import { KeyboardArrowRight } from '@mui/icons-material';
import { NavLink } from 'react-router-dom';

export default function OrderHistoryTiles({feedHandle1,data,orderData1}) {

  
const [date,setDate] = useState()

useEffect(()=>{

  const date = new Date(data.order_deatails.order_status_date);

const formattedDate = date.toLocaleDateString('en-GB', {
  day: '2-digit',
  month: 'long',
  year: 'numeric',
});

setDate(formattedDate)

},[data])


  const feedHandle = (data)=>{
    feedHandle1(data)
  }



  return (
    <div className="products bg-white shadow-lg h-48 rounded-lg mb-3 flex flex-col md:flex-row max-sm:h-72 max-lg:h-40">
      <div className="left w-full md:w-[30%] flex cursor-pointer group max-sm: max-sm:h-32">
        <img src={data.product_images[0].image} alt="product-image" className="w-full h-full group-hover:opacity-50"/>
      </div>
      <div className="right ml-[1.5%] w-full">
        <div className="product-name full text-amber-950 flex mt-4 pr-3 justify-between cursor-default max-lg:mt-0">
          <span className="product-name text-2xl font-semibold cursor-pointer">{data.product_name}</span>
          <div className="order-detail-container cursor-pointer group/order-details flex items-end">
            <span className="order-details group-hover/order-details:underline" onClick={()=>{feedHandle("orderdetail"); orderData1(data)}}>
            Order Details</span>
          </div>
        </div>
        <div className="product-specification w-[95%] h-16 overflow-hidden text-[85%] text-amber-950 cursor-default ">
            {data.specification}
        </div>
        <div className="product-bottom w-full flex items-center ">
          <div className="price-container flex flex-col w-1/2 cursor-default">
            <div className="price">
              <span className="text-amber-950 font-bold text-lg">Rs. {data.product_variant_discounted_price}</span>          
            </div>
            <div className="qty-button text-amber-950 ">
              <span className="quentity">Qty: {data.quantity}</span>
            </div>
          </div>
          <div className="product-buttons w-1/2 flex flex-col relative mr-5 text-end">
            <div className="transist-status w-full flex justify-end md:justify-end lg:justify-end xl:justify-end 2xl:justify-end">
              {/* <div className="status border border-amber-950 w-[35%] py-[1.5%] rounded-lg cursor-default text-center bg-[#ffdd59]">Pending</div> */}
              {/* <div className="status border border-amber-950 w-[35%] py-[1.5%] rounded-lg cursor-default text-center bg-[#f8f875]">Confirmed</div>
              <div className="status border border-amber-950 w-[35%] py-[1.5%] rounded-lg cursor-default text-center bg-[#ffdd59]">In Transist</div> */}
              <div className="status border border-amber-950 w-[35%] py-[1%] rounded-sm cursor-default text-center max-sm:w-24 ">{data.order_deatails.order_status}</div>
              {/* <div className="status border border-amber-950 w-[35%] py-[1.5%] rounded-lg cursor-default text-center bg-[#fa6262]">Cancelled</div> */}
            </div>
            <span className="date cursor-default max-sm:text-sm">{date?date:""}</span>
          </div>
        </div>
      </div>
    </div>
  )
}  
